import React, { useEffect, useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import WarningIcon from "@mui/icons-material/Warning";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { ValFormReg } from "../../../Validators/ValForms";
import { RegularExpressions } from "../../../Helpers/RegularExpression";
import { TextField } from "@mui/material";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import { GetDocumentpo } from "../../../Helpers/GetDocumento";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";



const MhusaValidarEnganche = ({
  folio,
  setLoader,
  loader,
  updateComentarios,
  // Inyectado por ModalSolicitudCredito (ver ModalSCScreens). Habilita
  // "Siguiente" tras validar el enganche, sin cerrar el modal.
  habilitarSiguiente,
}) => {
  const [comentarios, setComentarios] = useState("");
  const [estatus, setEstatus] = useState({});
  const [documento, setDocumento] = useState({
    documento: "",
    extension: "",
  });


  const onChange = (prop, value, sbool, smensaje) => {
    setComentarios(value);
  };
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: 34,
      responsable: "G",
    };
    request
      .post(`ACAnalisisDecicion`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  }, []);

  const onEnviarComentario = (accion) => {
    const rescomentarios = ValFormReg(
      "Comentarios",
      comentarios,
      RegularExpressions.TextSpecialCharacter,
      15,
      2000
    );
    if (rescomentarios.isValid === false) {
      Swal.fire(
        "ANALISIS DE SOLICITUD DE CREDITO",
        rescomentarios.mensaje,
        "error"
      );
      return;
    }
    if (
      documento.documento === undefined ||
      documento.documento === null ||
      documento.documento === ""
    ) {
      Swal.fire(
        "ANALISIS DE SOLICITUD DE CREDITO",
        "El documento digital del Enganche es obligatorio",
        "error"
      );
      return;
    }
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: 34,
      consecutivo: -1,
      comentarios,
      estatus: accion,
      iddocumento: 85,
      documento: documento.documento,
      extension: documento.extension,
    };
    request
      .post("ACTimeLineComentarios/GuardarEnganche", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result.estado);
        setComentarios("");
        if (updateComentarios !== undefined && updateComentarios !== null) {
          updateComentarios();

        }

        // Habilita "Siguiente" sin recargar data/estado ni cerrar el modal.
        if (habilitarSiguiente !== undefined && habilitarSiguiente !== null)
          habilitarSiguiente();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };

  const OnGetIcon = ({ icon }) => {
    switch (icon) {
      case "wait":
        return <PendingIcon />;
      case "success":
        return <CheckCircleIcon />;
      case "warning":
        return <WarningIcon />;
      case "error":
        return <ErrorIcon />;
      default:
        <></>;
    }
  };

  const onImprimirArchivo = () => {
    setLoader({ ...loader, mostrar: true });
    const iddocumento = 85;
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerDocumentoPedido?folio=${folio}&iddocumento=${Number(
          iddocumento
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = result.documento;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITUD DE CREDITO", error.mensaje, "error");
      });
  };

  return (
    <div className="analisis-credito-modal-mhusa">
      <div className="analisis-credito-modal-mhusa-content">
        <div className="analisis-credito-modal-mhusa-content-buttons">
          {estatus.habilitar === undefined ||
            estatus.habilitar === null ||
            estatus.habilitar === false ? (
            <div>
              <div
                className={"analisis-credito-modal-mhusa-content-pdf"}
                onClick={() => onImprimirArchivo()}
              >
                <CloudDownloadIcon />
                <div>Descargar enganche</div>
              </div>

              <div
                className={`analisis-credito-modal-mhusa-content-comentarios analisis-credito-modal-mhusa-content-comentarios-${estatus.icono}`}
              >
                <div className="analisis-credito-modal-mhusa-content-comentarios-svg">
                  <OnGetIcon icon={estatus.icono} />
                </div>
                <div className="analisis-credito-modal-mhusa-content-comentarios-div">
                  {estatus.comentarios}
                </div>
              </div>
            </div>
          ) : (
            <div className="analisis-credito-modal-mhusa-content-buttons-container">
              <TextField
                fullWidth
                size="small"
                label="COMENTARIOS"
                className="cel-1"
                multiline
                rows={4}
                type="text"
                // error={condiciones.bcondiciones}
                onChange={({ target }) => {
                  ValSpecialCharacters(
                    "condiciones",
                    target.value,
                    onChange,
                    true,
                    500
                  );
                }}
                value={comentarios}
              />
              <div>
                <TextField
                  fullWidth
                  type="file"
                  onChange={({ target }) => GetDocumentpo(target, setDocumento)}
                  sx={{ mt: 2 }}
                />
              </div>
              <dvi className="analisis-credito-modal-mhusa-content-buttons-container-buttons">
                <div
                  className="analisis-credito-modal-mhusa-content-acept-button"
                  onClick={() => {
                    onEnviarComentario("A");
                  }}
                >
                  <CheckCircleIcon />
                  <div>Validar enganche</div>
                </div>

                {/* <div
                    className="analisis-credito-modal-mhusa-content-cancel-button"
                    onClick={() => {
                      onEnviarComentario('M')
                    }}
                  >
                    <CancelIcon />
                    <div>RECHAZAR</div>
                  </div> */}
              </dvi>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MhusaValidarEnganche;
